import * as React from 'react'

import { ButtonWrapper } from '../../atoms/Button/RenderButton'
import Headings from '../../atoms/Heading'
import Image from '../../atoms/Image'
import Paragraph from '../../atoms/Paragraph'
import Video from '../../atoms/Video'
import JobsList from '../../organisms/JobsList'
import PageNotFound from '../../pages/PageNotFound'
import './style.css'

interface Props {
  content?: any
  background?: string
  marginBottom?: boolean
  isArticle?: boolean
}

/**
 * TextBlock Component
 * @param content - Content from the CMS.
 * @param background (optional) - Background color of the component. Expected values: "white" | "purple" | "orange" | "lightPurple" , Default: "white"
 * @param isArticle (optional) - To render article layout
 */
const TextBlock = ({ content, background = 'white', marginBottom = true, isArticle }: Props) => {
  background = background.toLowerCase()
  const columns = content?.cardLayout === '3' ? 'xl:w-[32%]' : content?.cardLayout === '4' ? 'xl:w-[23%]' : 'xl:w-[49%]'
  const bgColor =
    background === 'purple'
      ? 'bg-purple-100'
      : background === 'orange'
        ? 'bg-orange-10'
        : background === 'teal'
          ? 'bg-teal-10'
          : background === 'lightpurple'
            ? 'bg-purple-10'
            : 'bg-white'

  const isIconIncluded = (str) => {
    return str && str.toLowerCase().includes('icon')
  }
  return (
    <>
      {content?.componentName !== '404 page not found' ? (
        <div className="textBlock">
          <div data-testid="textBlock" className={`layoutSpacing ${bgColor}`}>
            <div
              className={`w-full ${bgColor !== 'bg-white' ? 'sectionSpacing' : 'sectionBottomSpacing'} ${
                bgColor !== 'bg-white' && marginBottom ? 'sectionBottomMargin' : ''
              } layout`}
            >
              <div id={content?.headline}>
                <div className={`flex flex-col ${content?.texColtLayout && 'gap-24 xl:flex-row'}`}>
                  {content?.headline && (
                    <Headings
                      variant="H2"
                      content={content?.headline}
                      classes={`text-purple-100 ${
                        !content?.texColtLayout && `w-100 ${isArticle ? '' : 'md:w-75 xl:w-60'}`
                      }`}
                    />
                  )}
                  {content?.subheadline && (
                    <Headings
                      variant="H3"
                      content={content?.subheadline}
                      classes={`text-purple-100 ${
                        !content?.texColtLayout && `w-100 ${isArticle ? '' : 'md:w-75 xl:w-60'}`
                      }`}
                    />
                  )}
                  <div>
                    <Paragraph
                      classes={`${!content?.texColtLayout && 'tableLayoutForPara'}`}
                      content={
                        content?.contentDescription || content?.bodyText || content?.description || content?.richText
                      }
                    />
                    {content?.texColtLayout && (
                      <div className={`${content.spacingAboveButtons ? 'mt-24' : ''}`}>
                        <ButtonWrapper content={content} columns={columns} />
                      </div>
                    )}
                  </div>
                </div>
                {content?.jobAdderPlugin && <JobsList />}
                {!content?.texColtLayout && (
                  <div className={`${content.spacingAboveButtons ? 'mt-24' : ''}`}>
                    <ButtonWrapper content={content} columns={columns} />
                  </div>
                )}
              </div>
              {content?.assets?.map((item, index) => (
                <div key={`${item?.fields?.title}-${index}`}>
                  {item?.fields?.file?.contentType.includes('image') && (
                    <>
                      {item?.fields?.title !== 'Map Image' && (
                        <div className={`w-100 ${isArticle ? '' : 'md:w-75 xl:w-60'}`}>
                          <Image
                            imageUrl={item?.fields?.file?.url}
                            altText={item?.fields?.description}
                            className={`${
                              content?.captions ? 'mb-16' : ''
                            } ${isIconIncluded(item?.fields?.title) && isIconIncluded(item?.fields?.description) ? 'w-56' : ''}`}
                            caption={content?.captions}
                          />
                        </div>
                      )}
                      {item?.fields?.title === 'Map Image' && (
                        <div className={`w-100`}>
                          <a href={item?.fields?.description} target={'_blank'} rel="noreferrer">
                            <Image
                              imageUrl={item?.fields?.file?.url}
                              altText={item?.fields?.title}
                              className={`${
                                content?.captions ? 'mb-16' : ''
                              } ${isIconIncluded(item?.fields?.title) && isIconIncluded(item?.fields?.description) ? 'w-56' : ''}`}
                              caption={content?.captions}
                            />
                          </a>
                        </div>
                      )}
                    </>
                  )}
                  {item?.fields?.file?.contentType.includes('video') && (
                    <div className={`w-100 ${isArticle ? '' : 'md:w-75 xl:w-60'}`}>
                      <Video
                        videoUrl={item?.fields?.file?.url}
                        classes={`${item?.fields?.caption ? 'mb-16' : ''}`}
                        caption={item?.fields?.captions}
                      />
                    </div>
                  )}
                </div>
              ))}
              {content?.video && (
                <div className={`w-100 ${isArticle ? '' : 'md:w-75 xl:w-60'}`}>
                  <Video
                    videoUrl={content?.video}
                    classes={`${content?.caption ? 'mb-16' : ''} mt-16`}
                    caption={content?.captions}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <PageNotFound content={content} />
      )}
    </>
  )
}

export default TextBlock
